import { useState } from "react";
import Modal from "react-modal";
import Select, {
  type CSSObjectWithLabel,
  type SingleValue,
} from "react-select";
import { MatcherType } from "../../../generated/graphql";
import { enumKeys } from "../../../utils/enum";

type AddFieldMatcherModalProps = {
  readonly isOpen: boolean;
  readonly onClose: () => void;
  readonly handleCreate: ({
    type,
    value,
  }: {
    type: MatcherType;
    value: string;
  }) => void;
};

const AddFieldMatcherModal = ({
  isOpen,
  onClose,
  handleCreate,
}: AddFieldMatcherModalProps) => {
  const [matcherType, setMatcherType] = useState<MatcherType>();
  const [matcherValue, setMatcherValue] = useState<string>("");

  const matcherTypeOptions = enumKeys(MatcherType).map((key) => ({
    value: MatcherType[key],
    label: MatcherType[key],
  }));

  return (
    <Modal
      contentLabel="Add field matcher"
      style={{
        content: {
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          height: "600px",
          width: "800px",
        },
      }}
      isOpen={isOpen}
      ariaHideApp={false}
      onRequestClose={onClose}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          color: "black",
        }}
      >
        <h3>Select matcher type</h3>
        <Select
          required
          options={matcherTypeOptions}
          styles={{
            control: (base: CSSObjectWithLabel) => ({
              ...base,
              width: "max-content",
              minWidth: "100%",
            }),
            menu: (base: CSSObjectWithLabel) => ({
              ...base,
              width: "max-content",
              minWidth: "100%",
            }),
          }}
          onChange={(
            option: SingleValue<{ label: string; value: MatcherType }>,
          ) => {
            if (option) {
              setMatcherType(option.value);
            }
          }}
        />
        <h3>Set value</h3>
        <input
          required
          value={matcherValue}
          onChange={(e) => {
            setMatcherValue(e.target.value);
          }}
        />
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          width: "100%",
          justifyContent: "center",
          marginTop: "20px",
        }}
      >
        <button
          style={{ marginRight: "10px", height: "30px" }}
          onClick={() => {
            if (matcherType == null) {
              alert("All values are required");
            } else {
              handleCreate({
                type: matcherType,
                value: matcherValue,
              });
            }
          }}
        >
          Add
        </button>
        <button onClick={onClose}>Cancel</button>
      </div>
    </Modal>
  );
};

export default AddFieldMatcherModal;
